// extracted by mini-css-extract-plugin
module.exports = {"flex":"Todos_flex__3ZP_z","flexBetween":"Todos_flexBetween__17x39","departmentWrapper":"Todos_departmentWrapper__1Z9I0","label":"Todos_label__3qf0c"};